import React, {useRef, useEffect} from 'react';
import './KindergartensTable.css';

const KindergartensTable = ({tableData, isChecked, onCheck, listChecked, uncheckAll, isFixed, registerRowRef, mapSelectedId, onRowHoverChange, scrollContainerRef, sentinelRef, hasMore}) => {

  const getRowClass = (i) => {

    const variant = i % 2 ?  "alternate" : "info"  ;

    switch (variant) {
      case 'alternate':
        return 'table-alternate';
      case 'info':
        return 'table-info';
      default:
        return '';
    }
  };

  const incheckRef = useRef();


  useEffect(()=>{if(listChecked.length > 0) incheckRef.current.indeterminate = true}, [listChecked]);


  const colSpan = isChecked ? 6 : 5;

  return (
    <div className="table-responsive kg-table-scroll-wrap" ref={scrollContainerRef}>
      <table className="table kindergartens-table">
        <thead>
          <tr>
            {isChecked && <th style={{ width: '36px' }}>  <input
                    type="checkbox"
                    onChange={uncheckAll}
                    checked={false}
                    className="table-list-uncheck-button"
                    disabled={isFixed}
                    ref={incheckRef}
                  /></th>}
            <th>Назва закладу</th>
            <th>Район</th>
            <th>Адреса</th>
            <th>Телефон</th>
            <th>Дії</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((kindergarten, i) => (
            <tr
              key={kindergarten._id}
              ref={registerRowRef ? (el) => registerRowRef(kindergarten._id, el) : undefined}
              className={`${getRowClass(i)} ${listChecked.includes(kindergarten._id) ? 'selected' : ''} ${mapSelectedId === kindergarten._id ? 'map-selected' : ''}`}
              onMouseEnter={() => onRowHoverChange && onRowHoverChange(kindergarten._id)}
              onMouseLeave={() => onRowHoverChange && onRowHoverChange(null, kindergarten._id)}
            >
              {isChecked && <td>
                  <input
                    type="checkbox"
                    checked={listChecked.includes(kindergarten._id)}
                    onChange={() => {onCheck(kindergarten._id)}}
                    disabled={isFixed}
                  />
              </td>}
              <td>{[kindergarten.number, kindergarten.name].join(" ")}</td>
              <td>{kindergarten.contacts.address.district}</td>
              <td>{kindergarten.contacts.address.string}</td>
              <td>{kindergarten.contacts.phones.join(",")}</td>
              <td>
                  <a href={`/object/${kindergarten._id}`} className="btn-link-blue">Переглянути</a>
              </td>
            </tr>
          ))}
          {/* Сентинел для infinite scroll всередині самої таблиці — рендериться
              завжди (щоб ref не втрачався), скролл-контейнер тут не window,
              а сам .kg-table-scroll-wrap, тож і слухати треба його */}
          {sentinelRef && (
            <tr ref={sentinelRef} className="kg-table-sentinel-row">
              <td colSpan={colSpan} className="kg-table-sentinel-cell">
                {hasMore && (
                  <div className="kg-infinite-scroll-loader">
                    <span className="kg-infinite-scroll-spinner" aria-hidden="true" />
                    <span>Завантаження...</span>
                  </div>
                )}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default KindergartensTable;